import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dateField", "dateDisplay", "startTimeSelect", "endTimeSelect", "quantityField", "form"]
  static values = {
    spaceId: Number,
    openTime: String,
    closeTime: String,
    maxPerUnit: Number,
    maxDurationMinutes: Number,
    today: String
  }

  // Called when a "Reservar" button is clicked on a slot row
  openForSlot(event) {
    const startTime = event.currentTarget.dataset.startTime
    const date = event.currentTarget.dataset.date

    this.dateFieldTarget.value = date
    this.dateDisplayTarget.textContent = this.formatDate(date)

    this.buildTimeOptions(startTime, date)

    // Open the DaisyUI v5 dialog modal
    document.getElementById("reservation-modal").showModal()
  }

  onStartTimeChanged() {
    const startTime = this.startTimeSelectTarget.value
    this.rebuildEndTimeOptions(startTime)
  }

  // Build both start and end time selects given the pre-selected start
  buildTimeOptions(preselectedStart, date) {
    let slots = this.generateSlots(this.openTimeValue, this.closeTimeValue)

    // On today, exclude slots in the past
    if (date === this.todayValue) {
      const now = new Date()
      const nowMinutes = now.getHours() * 60 + now.getMinutes()
      slots = slots.filter(slot => {
        const [h, m] = slot.split(":").map(Number)
        return h * 60 + m >= nowMinutes
      })
    }

    // Build start_time options (all slots except the last — need at least 15 min duration)
    this.startTimeSelectTarget.innerHTML = ""
    slots.slice(0, -1).forEach(slot => {
      const option = new Option(slot, slot, slot === preselectedStart, slot === preselectedStart)
      this.startTimeSelectTarget.add(option)
    })

    this.rebuildEndTimeOptions(preselectedStart)
  }

  // Build end_time options: only slots strictly after startTime, capped by maxDurationMinutes
  rebuildEndTimeOptions(startTime) {
    const slots = this.generateSlots(this.openTimeValue, this.closeTimeValue)
    const startIdx = slots.indexOf(startTime)
    let endSlots = slots.slice(startIdx + 1)

    if (this.maxDurationMinutesValue > 0) {
      const [sh, sm] = startTime.split(":").map(Number)
      const startMins = sh * 60 + sm
      endSlots = endSlots.filter(slot => {
        const [h, m] = slot.split(":").map(Number)
        return (h * 60 + m) - startMins <= this.maxDurationMinutesValue
      })
    }

    this.endTimeSelectTarget.innerHTML = ""
    endSlots.forEach(slot => {
      const option = new Option(slot, slot)
      this.endTimeSelectTarget.add(option)
    })
  }

  // Generate array of "HH:MM" strings from openTime to closeTime in 15-min steps
  generateSlots(openTime, closeTime) {
    const slots = []
    let [h, m] = openTime.split(":").map(Number)
    const [endH, endM] = closeTime.split(":").map(Number)
    const endMinutes = endH * 60 + endM

    while (h * 60 + m <= endMinutes) {
      slots.push(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`)
      m += 15
      if (m >= 60) { h += 1; m = 0 }
    }
    return slots
  }

  formatDate(isoDate) {
    const [year, month, day] = isoDate.split("-").map(Number)
    const date = new Date(year, month - 1, day)
    return date.toLocaleDateString("es-ES", { weekday: "long", year: "numeric", month: "long", day: "numeric" })
  }

  closeModal() {
    document.getElementById("reservation-modal").close()
  }

  // Pre-fill the block modal date and open it when coordinator clicks "Bloquear tiempo"
  openBlockModal(event) {
    const date = event.currentTarget.dataset.date
    const blockDateField = document.querySelector("[data-reservation-modal-target='blockDateField']")
    if (blockDateField) blockDateField.value = date
    document.getElementById("block-modal").showModal()
  }
}
